import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { X, Search, FileText } from "lucide-react";

const nomeCliente = (c) => [c.nome, c.cognome].filter(Boolean).join(" ").trim() || "Senza nome";

export default function SceltaClienteDialog({ titolo = "Per quale cliente?", onPick, onClose }) {
  const { data: clienti } = useQuery({ queryKey: ["clienti"], queryFn: async () => (await api.get("/clienti")).data });
  const [q, setQ] = useState("");
  const query = q.trim().toLowerCase();
  const trovati = (clienti || []).filter((c) => !query || nomeCliente(c).toLowerCase().includes(query));

  return (
    <div className="fixed inset-0 z-[60] bg-[#16233c]/40 backdrop-blur-sm flex items-center justify-center p-4" data-testid="scelta-cliente-dialog">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-4 border-t-2 border-[#C9A84C] max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-serif text-xl text-[#1A2B4A] flex items-center gap-2">
            <FileText className="w-4 h-4 text-[#C9A84C]" /> {titolo}
          </h3>
          <button data-testid="scelta-cliente-close" onClick={onClose} className="text-[#4a5568] hover:text-[#1A2B4A]"><X className="w-5 h-5" /></button>
        </div>
        <div className="flex items-center border border-[#1A2B4A]/20 rounded-sm px-2.5 mb-3 focus-within:border-[#C9A84C]">
          <Search className="w-4 h-4 text-[#4a5568] shrink-0" />
          <input data-testid="scelta-cliente-search" autoFocus value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Cerca un cliente…" className="w-full px-2 py-2 bg-transparent text-sm focus:outline-none" />
        </div>
        <div className="overflow-y-auto -mx-1 px-1">
          {trovati.length === 0 ? (
            <p className="text-sm text-[#4a5568] py-3">Nessun cliente trovato.</p>
          ) : trovati.map((c) => (
            <button key={c.id} data-testid={`scelta-cliente-option-${c.id}`} onClick={() => onPick(c)}
              className="w-full text-left px-3 py-2 text-sm hover:bg-[#f9f8f5] border-b border-[#1A2B4A]/5 last:border-0 rounded-sm">
              <span className="text-[#1A2B4A]">{nomeCliente(c)}</span>
              {c.telefono && <span className="text-[11px] text-[#8a93a6] ml-2">{c.telefono}</span>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
